export default "__VITE_ASSET__a5f4d726__"